module.exports = __webpack_public_path__ + "static/media/note.737fafeb.png";